import { IconType } from 'react-icons';
import {
  PiMusicNotes,
  PiMusicNote,
  PiMicrophoneStage,
  PiMicrophone,
  PiVinylRecord,
  PiHeadphones,
  PiMaskHappy,
  PiSmiley,
  PiPersonArmsSpread,
  PiBook,
  PiCamera,
  PiBuildings,
  PiPalette,
  PiFilmReel,
  PiSoccerBall,
  PiBasketball,
  PiTennisBall,
  PiBicycle,
  PiPersonSimpleRun,
  PiBarbell,
  PiGameController,
  PiSword,
  PiTrophy,
  PiConfetti,
  PiHouseLine,
  PiFlag,
  PiFlagBanner,
  PiTent,
  PiTShirt,
  PiMartini,
  PiWine,
  PiBeerStein,
  PiHamburger,
  PiForkKnife,
  PiGraduationCap,
  PiChalkboardTeacher,
  PiChalkboard,
  PiToolbox,
  PiPresentation,
  PiPresentationChart,
  PiChatCircleText,
  PiUsersThree,
  PiHandshake,
  PiTagSimple,
} from 'react-icons/pi';

// Maps the backend's `slug` field (English, snake_case) to a Phosphor icon.
// Unknown slugs fall back to `PiTagSimple`.
const ICON_BY_SLUG: Record<string, IconType> = {
  // Música — géneros y formatos
  music: PiMusicNotes,
  concerts: PiMicrophoneStage,
  multi_genre: PiMusicNotes,
  classical: PiMusicNote,
  pop: PiMusicNotes,
  indie: PiMusicNotes,
  rock: PiVinylRecord,
  metal: PiVinylRecord,
  punk: PiVinylRecord,
  blues: PiVinylRecord,
  jazz: PiVinylRecord,
  soul: PiVinylRecord,
  electronic: PiHeadphones,
  techno: PiHeadphones,
  house: PiHeadphones,
  trap: PiHeadphones,
  rap_hiphop: PiMicrophone,
  reggaeton: PiMusicNotes,
  reggae: PiMusicNotes,
  folk: PiMusicNotes,
  tango: PiMusicNotes,
  cumbia: PiMusicNotes,
  salsa: PiMusicNotes,

  // Escénicas
  theater: PiMaskHappy,
  musicals: PiMaskHappy,
  opera: PiMicrophoneStage,
  dance: PiPersonArmsSpread,
  ballet: PiPersonArmsSpread,
  stand_up: PiMicrophone,
  comedy: PiSmiley,

  // Cultura
  cultural: PiBuildings,
  heritage: PiBuildings,
  art: PiPalette,
  photography: PiCamera,
  literature: PiBook,
  cinema: PiFilmReel,
  exhibitions: PiBuildings,

  // Deportes
  sports: PiTrophy,
  soccer: PiSoccerBall,
  basketball: PiBasketball,
  tennis: PiTennisBall,
  cycling: PiBicycle,
  running: PiPersonSimpleRun,
  boxing: PiBarbell,
  martial_arts: PiSword,
  esports: PiGameController,

  // Fiesta / festividades
  parties: PiConfetti,
  carnivals: PiConfetti,
  local_festivities: PiFlagBanner,
  national_holidays: PiFlag,
  nightclub: PiHouseLine,

  // Ferias / lanzamientos
  fairs: PiTent,
  product_launches: PiPresentationChart,
  fashion_shows: PiTShirt,

  // Gastronomía
  gastronomy: PiMartini,
  wine_tastings: PiWine,
  beer_tastings: PiBeerStein,
  street_food: PiHamburger,
  food: PiForkKnife,

  // Aprendizaje / profesional
  educational: PiChalkboard,
  masterclasses: PiGraduationCap,
  seminars: PiChalkboardTeacher,
  workshops: PiToolbox,
  conferences: PiPresentation,
  congresses: PiUsersThree,
  talks: PiChatCircleText,
  networking: PiHandshake,
};

const getCategoryIcon = (slug: string): IconType => ICON_BY_SLUG[slug] || PiTagSimple;

export default getCategoryIcon;
